import type { AdDesignData, AdDesignShowDefaultsResponse } from '@jobilla/nexus-sdk'
import { ReactNode } from 'react'
import { GalleryCard } from './gallery-card'

export interface GalleryGridProps {
	designs: AdDesignData[]
	defaults?: AdDesignShowDefaultsResponse | null
	selectedId?: string | null
	onSelect?: (design: AdDesignData) => void
	onRename?: (design: AdDesignData) => void
	onDelete?: (design: AdDesignData) => void
	onSetDefaultFeed?: (design: AdDesignData) => void
	onSetDefaultStory?: (design: AdDesignData) => void
	showActions?: boolean
	emptyState?: ReactNode
}

export function GalleryGrid({
	designs,
	defaults,
	selectedId,
	onSelect,
	onRename,
	onDelete,
	onSetDefaultFeed,
	onSetDefaultStory,
	showActions = true,
	emptyState,
}: GalleryGridProps) {
	if (designs.length === 0 && emptyState) {
		return <>{emptyState}</>
	}

	return (
		<div className="grid grid-cols-[repeat(auto-fill,320px)] gap-5">
			{designs.map((design) => (
				<GalleryCard
					key={design.id}
					design={design}
					selected={selectedId === design.id}
					onSelect={onSelect}
					onRename={onRename}
					onDelete={onDelete}
					onSetDefaultFeed={onSetDefaultFeed}
					onSetDefaultStory={onSetDefaultStory}
					isDefaultFeed={defaults?.feed?.id === design.id}
					isDefaultStory={defaults?.story?.id === design.id}
					showActions={showActions}
				/>
			))}
		</div>
	)
}
